import styles from "./ProjectKeypoints.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Highlights = ({ icon, title, description }) => {
  return (
    <div className={styles.keypoint}>
      <div className={styles.iconWrapper}>
        <div className={styles.icon}>
          <FontAwesomeIcon icon={icon} />
        </div>
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

const ProjectHighlights = ({ highlights }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {highlights.map((highlight) => (
          <Highlights
            key={highlight.title}
            icon={highlight.icon}
            title={highlight.title}
            description={highlight.description}
          />
        ))}
      </div>
    </div>
  );
};

export default ProjectHighlights;
